export enum StepCd {
  WAITING = "000", // 접수대기
  RECEIVED = "100", // 접수
  ACCEPTED = "200", // 주문 수락
  PICKUP_REQUEST = "300", // 픽업요청
  COOKING_COMPLETED = "400", // 조리완료
  DELIVERY_REQUEST = "500", // 배달요청
  ORDER_COMPLETED = "700", // 주문완료
  ORDER_CANCELLED = "900", // 주문취소
}